import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import {
  OUTBOUND_ICON,
  OUTBOUND_ICON_FILLED,
} from "../../../../redo-suite/order-management-cloud";

export const PickupsItem = memo(function PickupsItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.SCAN_AND_VERIFY,
  );

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.ordersOutboundLabelsHref + "/pickups",
      }}
      FilledIcon={OUTBOUND_ICON_FILLED}
      friendlyName={t("Carrier pickups ({{carrierName}})", {
        carrierName: "UPS",
        context:
          "navigation label for scheduling pickups with the named carrier",
      })}
      id="pickups"
      UnfilledIcon={OUTBOUND_ICON}
    />
  );
});
